import React from 'react';

import * as S from './ChartError.styles';

export interface ChartErrorLocales {
  imgAlt: string;
  title: string;
  description: string;
  linkAlt: string;
}

export interface ChartErrorProps {
  supportEmail: string;
  locales: ChartErrorLocales;
}

export const ChartError = ({ supportEmail, locales }: ChartErrorProps) => {
  return (
    <S.ChartErrorRoot data-testid="chart-error">
      <S.ErrorImage alt={locales.imgAlt} />
      <S.Title>{locales.title}</S.Title>
      <S.Description>
        {locales.description}
        <S.Link title={locales.linkAlt} href={`mailto:${supportEmail}`}>
          {supportEmail}
        </S.Link>
      </S.Description>
    </S.ChartErrorRoot>
  );
};
